import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './OrganizationJobCategoriesView.css';

import { apiUrl } from '../../../utility/Connections';

import { Layout, Divider } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import TableJobCategories from '../../../components/tableJobCategories/tableJobCategories';
import FormJobCategories from '../../../components/formJobCategories/formJobCategories';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import Search from '../../../components/search/search';
const { Content } = Layout;

const OrganizationJobCategoriesView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [filteredDataJobCategories, setFilteredDataJobCategories] = useState([]);
    const [dataJobCategories, setDataJobCategories] = useState([]);
    const [orgId, setOrgId] = useState("");
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getJobCategories(current_org.org_id);
        }
    }, []);

    const getJobCategories = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando categorías de cargo de la organización...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/job-categories/get-job-categories/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataJobCategories(data);
                setShowLoading(false);
                if (searchText) {
                    filterData(searchText, data)
                } else {
                    setFilteredDataJobCategories(data);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para agregar un nuevo registro de categoría de cargo
    const addJobCategory = (newJobCategory) => {
        setShowLoading(true);
        setLoadingText("Agregando categoría de cargo...")

        const formData = new FormData();
        formData.append("jct_org_id", orgId);
        formData.append("jct_category", newJobCategory);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.post(`${apiUrl}/job-categories/create-job-category/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getJobCategories(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para editar el nombre de un categoría de cargo
    const handleInputChangeTable = (jct_id, jobCategory) => {
        setShowLoading(true);
        setLoadingText("Guardando categoría de cargo...")

        const formData = new FormData();
        formData.append("jct_id", jct_id);
        formData.append("jct_category", jobCategory);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/job-categories/update-job-category/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getJobCategories(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    // Función para eliminar un registro de categoría de cargo
    const handleDeleteTable = (jct_id) => {
        setShowLoading(true);
        setLoadingText("Eliminando categoría de cargo...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.delete(`${apiUrl}/job-categories/delete-job-category/${jct_id}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getJobCategories(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const onSearch = (value) => {
        setSearchText(value)
        filterData(value, dataJobCategories)
    }

    const filterData = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataJobCategories(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.jct_category.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataJobCategories(filtered);
        }
    }

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            <div className='layout-content'>
                <FormJobCategories addJobCategory={addJobCategory} />
            </div>
            <Divider />
            <div className='layout-content'>
                <Search onSearch={onSearch} />
                <br></br>
                <TableJobCategories data={filteredDataJobCategories} handleInputChange={handleInputChangeTable} handleDelete={handleDeleteTable} />
            </div>
        </Content>
    </div>
}

export default OrganizationJobCategoriesView;